<template>
<div class="dropdown-menu dropdown-menu-right">
    <slot></slot>
</div>
</template>

<script>
export default {
    
}
</script>